export default __webpack_public_path__ + "files/9182cad8b589d582122aac48036f50e3.mp3";